<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="slu-students"
            :items="sluStudents"
            :fields="studentFields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-open btn-open-student btn-"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.open')"
                    @click="openStudent(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-student-index-tab-component',
    props: ['sluStudentsIn'],
    data() {
        return {
            studentFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        sluStudents() {
            return this.sluStudentsIn.map((student) => {
                return {
                    id: student.id,
                    full_name: student.full_name,
                };
            });
        },
    },
    methods: {
        openStudent(userId) {
            window.location.href = this.routes.sluStudentBoard(userId);
        },
    },
};
</script>

<style scoped></style>
